import React, { Fragment } from "react";
import { Breakpoint } from 'react-socks';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router";
import ExtendedLink from "./ExtendedLink";
import TrustBoxReviewCountContainer from '../containers/TrustBoxReviewCountContainer';

export default function (props) {
    const { t } = useTranslation();
    const history = useHistory();
    const { settings } = props;
    const location = useLocation();

    const showTrustPilot = settings.trustPilotBusinessUnitId && settings.customDomain && settings.isCatalogueMode !== true;
    // const isSearcPluginMode =  settings.isCatalogueMode  && settings.isSearcPluginMode  === true;
    const isNotInsideNearbyConsultants = location.pathname !== '/nearby-consultants';
    const showBackButtonPlugin = settings.isCatalogueMode && settings.isSearcPluginMode === true && location.pathname === '/contactrep';
    const showBackButtonCatalogue = settings.isCatalogueMode === true && settings.isSearcPluginMode === false && (location.pathname !== '/' && location.pathname !== '/categories');;
    return (
        <Fragment>


            <div className="page-title">
                <div className={`${(settings.isCatalogueMode ? "container-fluid" : "container")}`}>
                    <div className="column">
                        <Breakpoint small down>
                            <h3 className={`${(settings.isCatalogueMode ? "cat-header-title" : "")}`}>{props.title}</h3>
                        </Breakpoint>
                        <Breakpoint medium up>
                            <h1>{props.title}</h1>
                        </Breakpoint>
                    </div>
                    {showTrustPilot && <div className="column">
                        <TrustBoxReviewCountContainer />
                    </div>}
                    {settings.isAppMode  !== true && <div className="column">
                        <ul className={`${(settings.isCatalogueMode ? "cat-breadcrumbs breadcrumbs" : "breadcrumbs")}`}>
                            {(settings.isCatalogueMode !== true && settings.isSearcPluginMode !== true) &&
                                <Fragment>
                                    <li> <ExtendedLink to={`${settings.baseUrl}${settings.catalogueUrl}`}>{t("Home")} </ExtendedLink> </li>
                                    <li className="separator">&nbsp;</li>
                                    <li>{props.title}</li>
                                </Fragment>
                            }
                            {(settings.isCatalogueMode === true && settings.isSearcPluginMode !== true && isNotInsideNearbyConsultants) &&
                                <li className={`${(settings.isCatalogueMode ? "cat-breadcrumbs-li" : "")}`}>
                                    <ExtendedLink to={`${settings.baseUrl}nearby-consultants`}
                                        className={`${(showBackButtonCatalogue || showBackButtonPlugin) ? "btn btn-outline-primary btn-sm overflow-text" : "btn btn-outline-primary btn-sm overflow-text btn-Catalogue-back"}`} >
                                        {t("Consultant Search")}
                                    </ExtendedLink>
                                </li>}
                            {(showBackButtonCatalogue || showBackButtonPlugin) &&
                                <li className={`${(settings.isCatalogueMode ? "cat-breadcrumbs-li" : "")}`}>
                                    <button className="btn btn-sm k-button btn-outline-primary btn-Catalogue-back" onClick={() => history.go(-1)}>{t("Go Back")}
                                    </button>
                                </li>}


                        </ul>
                    </div>}
                </div>
            </div>

        </Fragment>
    );
}


